const data = {
  menu: {
    member: [
      // first section
      [
        {
          name: 'Meet Our Experts',
          icon: 'expert',
          key: 'REVIEW_WEB_URL',
          path: '/expert/users',
          children: [],
          new: false,
        },
        {
          name: 'My Review',
          icon: 'my-review',
          key: 'SOCO_WEB_URL',
          path: '/journal/review',
          children: [],
        },
        {
          name: 'Bookmark',
          icon: 'bookmark',
          key: 'SOCO_WEB_URL',
          path: '/journal/bookmark',
          children: [],
        },
        {
          name: 'Wishlist',
          icon: 'wishlist',
          key: 'SOCO_WEB_URL',
          path: '/shopping/wishlist',
          children: [],
        },
        // {
        //   name: 'Recommended for you',
        //   icon: 'love',
        //   url: '/our-curated-selection',
        //   children: [],
        //   new: false,
        // },
        // {
        //   name: 'Points & Rewards',
        //   icon: 'coupon',
        //   children: [
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'My Points',
        //       path: '/profile/points-rewards',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Get Member',
        //       path: '/profile/get-member',
        //     },
        //   ],
        // },
        // {
        //   name: 'My Profile',
        //   icon: 'profile',
        //   children: [
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Profile Detail',
        //       path: '/timeline',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Beauty Profile',
        //       path: '/profile/beauty',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Preferences',
        //       path: '/profile/preferences',
        //     },
        //   ],
        // },
        // {
        //   name: 'My Journal',
        //   icon: 'journal',
        //   children: [
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Article',
        //       path: '/journal/articles',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Video',
        //       path: '/journal/videos',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Review',
        //       path: '/journal/review',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Collection',
        //       path: '/journal/collection',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Photo',
        //       path: '/journal/photos',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Polling',
        //       path: '/journal/polling',
        //     },
        //     {
        //       key: 'SOCO_WEB_URL',
        //       name: 'Bookmark',
        //       path: '/journal/bookmark',
        //     },
        //   ],
        // },
      ],

      // second section
      [
        {
          key: 'SOCIOLLA_WEB_URL',
          name: 'Sociolla',
          icon: 's-web',
          path: '',
        },
        {
          key: 'BJ_WEB_URL',
          name: 'Beauty Journal',
          icon: 'bj-web',
          path: '',
        },
        {
          key: 'LULLA_WEB_URL',
          name: 'lilla',
          icon: 'l-web',
          path: '',
        },
        // {
        //   key: 'REVIEW_WEB_URL',
        //   name: 'Review',
        //   icon: 'r-web',
        //   path: '',
        // },
      ],

      // third section
      // [
      //   {
      //     name: 'Information',
      //     icon: 'info',
      //     children: [
      //       {
      //         key: 'SOCO_WEB_URL',
      //         name: 'Tentang Kami',
      //         path: '/page/aboutus',
      //       },
      //       {
      //         key: 'SOCO_WEB_URL',
      //         name: 'Kebijakan Privasi',
      //         path: '/page/privacypolicy',
      //       },
      //       {
      //         key: 'SOCO_WEB_URL',
      //         name: 'Syarat dan Ketentuan',
      //         path: '/page/termsandconditions',
      //       },
      //       {
      //         key: 'SOCO_WEB_URL',
      //         name: 'Pusat Bantuan',
      //         path: '/page/help',
      //       },
      //       {
      //         key: 'SOCO_WEB_URL',
      //         name: 'Kontak Kami',
      //         path: '/page/contactus',
      //       },
      //     ],
      //   },
      // ],
    ],

    guest: [
      [
        {
            name: 'Meet Our Experts',
            icon: 'expert',
            key: 'REVIEW_WEB_URL',
            path: '/expert/users',
            children: [],
            new: false,
          },
      ],
      [
        {
          key: 'SOCIOLLA_WEB_URL',
          name: 'Sociolla',
          icon: 's-web',
          path: '',
        },
        {
          key: 'BJ_WEB_URL',
          name: 'Beauty Journal',
          icon: 'bj-web',
          path: '',
        },
        {
          key: 'LULLA_WEB_URL',
          name: 'lilla',
          icon: 'l-web',
          path: '',
        },
      ],
    ],
  },
};

export default data;
